/* Wombshine: flip card for ws-split-feature. Click the image or the button
   to turn it over; the hidden face is aria-hidden so screen readers get the
   right alt text for whichever side is showing. */
(function () {
  document.querySelectorAll('[data-ws-flip]').forEach(function (flip) {
    if (flip.dataset.wsFlipReady) return;
    flip.dataset.wsFlipReady = '1';
    var toggle = flip.parentElement.querySelector('.ws-flip__toggle');
    var faces = flip.querySelectorAll('.ws-flip__face');
    function set(flipped) {
      flip.classList.toggle('is-flipped', flipped);
      faces[0].setAttribute('aria-hidden', flipped ? 'true' : 'false');
      faces[1].setAttribute('aria-hidden', flipped ? 'false' : 'true');
      if (toggle) {
        toggle.setAttribute('aria-pressed', flipped ? 'true' : 'false');
        toggle.querySelector('span').textContent = flipped ? toggle.dataset.labelBack : toggle.dataset.labelFront;
      }
    }
    flip.addEventListener('click', function () { set(!flip.classList.contains('is-flipped')); });
    if (toggle) toggle.addEventListener('click', function () { set(!flip.classList.contains('is-flipped')); });
  });
})();
